import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import includes from 'lodash/includes';
import find from 'lodash/find';

import {
    STYLE_FILL,
    STYLE_NEUTRAL,
} from 'eventbrite_design_system/button/constants';

import lazyGettext from 'js-utils/lazy-gettext';
import { AU_LOCALE } from 'js-utils/intl';
import {
    PACKAGE_ONE_VERSION_1,
    PACKAGE_ONE_VERSION_2,
    PACKAGE_VERSION_1,
    PACKAGE_VERSION_2,
    PACKAGE_ONE,
    PACKAGE_TWO,
    PACKAGE_THREE,
    LOCALE_WITH_VERSION_2,
} from '../../constants/main';
import {
    PACKAGE_ONE_FEATURES_AU_V2,
    PACKAGE_TWO_FEATURES_AU,
} from '../../constants/features';
import { canUpdateEssentialsV2 } from '../utils';

const OVERRIDE_USER_SETTINGS_VERSION_2 = {
    [PACKAGE_ONE_VERSION_1]: {
        packagesList: {
            CTAs: [
                lazyGettext('Update'),
                lazyGettext('Upgrade'),
                lazyGettext('Contact Us'),
            ],
            CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        },
        grid: {
            CTAs: [
                lazyGettext('Update'),
                lazyGettext('Upgrade'),
                lazyGettext('Contact Us'),
            ],
            CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        },
    },
};

const OVERRIDE_PACKAGE_LIST_PACKAGES_ESSENTIALS_VERSION_2 = {
    [AU_LOCALE]: {
        packagesList: {
            packages: {
                [PACKAGE_ONE]: {
                    features: PACKAGE_ONE_FEATURES_AU_V2,
                },
                [PACKAGE_TWO]: {
                    features: PACKAGE_TWO_FEATURES_AU,
                },
            },
        },
    },
};

/**
 * Generate additional settings to override the features list and the CTA texts/styles
 * on the essentials package on Australia when the FF launchPackageEssentialV2 is on.
 */
export const generateAdditionalSettings = ({
    locale,
    isAuthenticated,
    launchPackageEssentialV2,
    assortmentsAvailability = {},
}) => {
    const { current: currentPackage = {} } = assortmentsAvailability || {};
    const { plan, version } = currentPackage;
    let userSettings = {};
    let overrideSettings = {};

    if (!launchPackageEssentialV2 || !includes(LOCALE_WITH_VERSION_2, locale)) {
        return;
    }

    if (
        isAuthenticated &&
        canUpdateEssentialsV2({ locale, assortmentsAvailability })
    ) {
        userSettings = OVERRIDE_USER_SETTINGS_VERSION_2[PACKAGE_ONE_VERSION_1];
    }

    overrideSettings =
        OVERRIDE_PACKAGE_LIST_PACKAGES_ESSENTIALS_VERSION_2[locale];

    return merge(overrideSettings, userSettings);
};
